import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '@app/shared/services/Login.service';
import { HttpErrorResponse } from '@angular/common/http';
import { LayoutService } from '@app/shared/services/layout.service';
import { CommonService } from '@product/shared/services/common.service';
import { MenuModel } from '@app/shared/interfaces/menu-model';
import { Observable, switchMap, tap } from 'rxjs';
// import { ReCaptchaV3Service } from 'ng-recaptcha';
import { AppConfigService } from '@app/shared/services/app-config.service';

@Component({
  selector: 'app-login',
  templateUrl: './Login.component.html',
  styleUrls: ['./Login.component.less'],
})
export class LoginComponent implements OnInit {
  @Input() hideTitle = false;
  @Input() hideButton = false;
  @Input() navigateAfter = true;
  passwordVisible = false;
  siteKey = '';
  constructor(
    private service: LoginService,
    private router: Router,
    private layoutService: LayoutService,
    private commonService: CommonService,
    // private recaptcha: ReCaptchaV3Service
  ) {}
  Username: string;
  Password: string;
  ngOnInit(): void {  
    setTimeout(() => {
      if (this.service.loginStatus.value === true) {
        this.router.navigate(['/']);
      }
    }, 250);
    this.siteKey = AppConfigService.settings.recaptchaSiteKey ?? '';
  }
  Login() {
    // this.recaptcha
    //   .execute('login')
    //   .pipe(
    //     switchMap(() => this.attempLogin())
    //     )
    //   .subscribe();
    this.attempLogin().subscribe();
  }

  attempLogin(): Observable<any> {
    return this.service.Login(this.Username, this.Password).pipe(
      tap(
        (result: any) => {
          localStorage.setItem('token', result.token);
          localStorage.setItem('refreshToken', result.refreshToken);
          this.router.navigate(['/']);
          this.service.loginStatus.next(true);
          // if (this.layoutService.menus == null) {
          //   this.layoutService.getMenu('main', (d: MenuModel) => {
          //     this.layoutService.menus = d;
          //   });
          // }
          if (
            this.commonService.dropDownMetaData['languages'] == null ||
            (this.commonService.dropDownMetaData['languages'] != null &&
              this.commonService.dropDownMetaData['languages'].length == 0)
          ) {
            this.commonService
              .getLanguages()
              .pipe(
                tap((response) => {
                  this.commonService.dropDownMetaData['languages'] =
                    response.value.map((lang) => {
                      return {
                        Code: lang.Id,
                        Label: lang.Name,
                        Additional: lang.Isocode,
                      };
                    });
                  this.commonService.dropDownMetaData['languages'].push({
                    Code: 0,
                    Label: 'Default',
                    Additional: 'DEFAULT',
                  });
                  //console.log(this.commonService.dropDownMetaData['languages']);
                })
              )
              .subscribe();
          }
        },
        (error: HttpErrorResponse) => {
          this.service.loginStatus.next(false);
        }
      )
    );
  }
}
